import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { TabsetComponent, ToastService } from 'ng-uikit-pro-standard';
import { RutService } from "src/app/shared/services/rut.service";
import * as _ from 'lodash'
import { ConsoleService } from "src/app/shared/services/console.service";
import { ProductosFormAddEditComponent } from "../form-add-edit/form-add-edit.component";
import { producto } from "src/app/shared/object/producto.model";
import { ProductosFormDatosComercialesComponent } from "../form-datos-comerciales/form-datos-comerciales.component";
import { FormStockComponent } from "../form-stock/form-stock.component";
import { ParametroEmpresaService } from "src/app/services/parametro-empresa.service";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import { ModalConfirmComponent } from "src/app/shared/components/modal-confirm/modal-confirm.component";
import { ProductoService } from "src/app/services/producto.service";

@Component({
  selector: 'app-productos-modal-add',
  templateUrl: './modal-add.component.html',
  styleUrls: ['../productos.component.scss'],
  providers: [SecurityService]
})
export class ProductoModalAddComponent implements OnInit {

  private client: GraphQLClient = null;

  // Output
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>()

  // Modales
  @ViewChild('addEditProducto', { static: true }) addEditProductoModal: ModalDirective;
  @ViewChild('staticTabs', { static: true }) staticTabs: TabsetComponent
  @ViewChild(ProductosFormAddEditComponent, { static: true }) addEditProductoComponent: ProductosFormAddEditComponent
  @ViewChild(ProductosFormDatosComercialesComponent, { static: true }) datosComercialesComponent: ProductosFormDatosComercialesComponent
  @ViewChild(FormStockComponent, { static: true }) formStockComponent: FormStockComponent
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent

  mode: 'ADD' | 'EDIT';
  rut_empresa: number;
  sucursal_codigo: number;
  codgo_modulo: number = 2;
  rut_usuario: number;
  parametro_iva: number;
  step: number = 1;
  codigoProductoNuevo: number = null;

  // Utils
  private log: any

  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private parametroEmpresaService: ParametroEmpresaService,
    private toastService: ToastService,
    private rutService: RutService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private productoService: ProductoService
  ) {
    this.client = client;
    this.log = this.clog.log('PRODUCTOS MODAL ADD/EDIT')
  }

  ngOnInit() {
    this.rut_empresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursal_codigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rut_usuario = Number(this.accesolocalstorage.getRutUsuario())
    this.codigoProductoNuevo = null
  }

  setParametroIVA() {
    this.parametroEmpresaService.obtenerIVA(this.rut_empresa, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.parametro_iva = respuesta.valor_numerico
      this.log('IVA', this.parametro_iva)
    })
  }

  showNew() {
    this.mode = "ADD"
    this.step = 1
    this.staticTabs.setActiveTab(this.step)
    this.codigoProductoNuevo = null
    this.addEditProductoComponent.showNew()
    this.addEditProductoModal.show()
    this.datosComercialesComponent.disable()
    this.setParametroIVA()
  }

  // showEdit(pro: producto) {
  //   this.mode = "EDIT"
  //   this.addEditProductoComponent.showEdit(pro)
  //   this.addEditProductoModal.show()
  // }

  guardarDatosProducto() {
    const isValid = this.addEditProductoComponent.validate()
    if (!isValid) {
      this.toastService.warning('Complete el formulario')
      return
    }

    this.addEditProductoComponent.guardar()
  }

  onSuccessSaveProducto(codigo) {
    this.log('product saved', codigo)
    this.step = 2
    this.addEditProductoComponent.disable()

    this.datosComercialesComponent.enable()
    const prod = new producto()
    prod.codigo = codigo
    this.codigoProductoNuevo = codigo
    this.datosComercialesComponent.loadAndShow(prod, this.parametro_iva)

    this.staticTabs.setActiveTab(this.step)
  }

  guardarDatosComerciales() {
    const isValid = this.datosComercialesComponent.validate()
    if (!isValid) {
      this.toastService.warning('Complete el formulario')
      return
    }
    this.datosComercialesComponent.actualizarDatosComerciales()
  }

  onSucessSaveDatosComerciales() {
    this.modalConfirm.showWithInlineConfig('Activar producto', '¿Desea activar el producto?',
      () => {
        const producto = {
          entidad: {
            empresa_rut: Number(this.rut_empresa),
            codigo: this.codigoProductoNuevo,
            activo: true
          }
        }
        this.productoService.cambiarEstado(producto, ({ respuesta, mensajes }) => {
          if (mensajes && mensajes.length > 0) {
            this.messageRendererService.showErrors(mensajes)
            return
          }
          this.showSuccess('Producto activado')
          this.addEditProductoModal.hide()
          this.onSuccess.emit()
        })
      },
      () => {
        this.addEditProductoModal.hide()
        this.onSuccess.emit()
      })
  }

  showSuccess(mensaje: string = 'Registro grabado!') {
    const options = { opacity: 1 };
    this.toastService.success(mensaje, 'Información!', options);
  }

}
